import { fmtDate, fmtEur, fmtMwhc } from "@/lib/format";

const bonusKwhc = (r) => (r.cdp_bonus_kwhc || 0) + (r.cpe_bonus_kwhc || 0) + (r.zni_bonus_kwhc || 0);

export const METRICS = [
  { key: "client", label: "Client", get: (s) => s.client || "—" },
  { key: "zone", label: "Zone / code postal", get: (s) => `${s.zone} · ${s.postal_code || "—"}` },
  { key: "engagement", label: "Date d'engagement", get: (s) => (s.engagement_date ? fmtDate(s.engagement_date) : "—") },
  { key: "status", label: "Statut", get: () => "Simulation (comparateur)" },
  { key: "price", label: "Prix CEE", get: (s) => `${s.result?.cee_price ?? 0} €/MWhc`, num: (s) => s.result?.cee_price || 0, unit: "€/MWhc" },
  { key: "kwhc", label: "Volume ferme", get: (s) => fmtMwhc(s.result?.total_kwhc), num: (s) => s.result?.total_kwhc || 0, fmt: fmtMwhc },
  { key: "opt_kwhc", label: "Volume options", get: (s) => fmtMwhc(s.result?.options_kwhc), num: (s) => s.result?.options_kwhc || 0, fmt: fmtMwhc, optional: true },
  { key: "prime", label: "Prime ferme", get: (s) => fmtEur(s.result?.total_prime), num: (s) => s.result?.total_prime || 0, fmt: fmtEur, strong: true },
  { key: "prime_opt", label: "Prime avec options", get: (s) => fmtEur(s.result?.total_with_options_prime), num: (s) => s.result?.total_with_options_prime || 0, fmt: fmtEur, optional: true, hideIf: (s) => !s.result?.options_kwhc },
  { key: "precaire", label: "Part précarité", get: (s) => fmtMwhc(s.result?.total_kwhc_precaire), num: (s) => s.result?.total_kwhc_precaire || 0, fmt: fmtMwhc, optional: true },
  { key: "bonus", label: "Bonifications", get: (s) => fmtMwhc(bonusKwhc(s.result || {})), num: (s) => bonusKwhc(s.result || {}), fmt: fmtMwhc, optional: true },
];

export const visibleMetrics = (sims) =>
  METRICS.filter((m) => !m.optional || sims.some((s) => (m.hideIf ? !m.hideIf(s) : m.num(s) > 0)));

export const deltaOf = (m, s, ref) => {
  if (!m.num || s.id === ref.id) return null;
  const d = m.num(s) - m.num(ref);
  const base = m.num(ref);
  return { d, pct: base ? (d / base) * 100 : null };
};

const Delta = ({ m, s, refSim }) => {
  const r = deltaOf(m, s, refSim);
  if (!r || Math.abs(r.d) < 0.005) return r ? <div className="text-[11px] text-muted-foreground">= référence</div> : null;
  const up = r.d > 0;
  const txt = m.fmt ? m.fmt(Math.abs(r.d)) : `${Math.abs(r.d).toLocaleString("fr-FR")} ${m.unit || ""}`;
  return (
    <div className={`text-[11px] font-semibold ${up ? "text-green-700" : "text-red-700"}`} data-testid={`delta-${m.key}-${s.id}`}>
      {up ? "+" : "−"}{txt}{r.pct !== null ? ` (${up ? "+" : "−"}${Math.abs(r.pct).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} %)` : ""}
    </div>
  );
};

export const CompareTable = ({ sims, refSim }) => (
  <div className="overflow-x-auto rounded-xl border border-border" data-testid="compare-table">
    <table className="w-full text-sm min-w-[640px]">
      <thead>
        <tr className="bg-secondary/60">
          <th className="text-left px-4 py-3 font-semibold w-48">Indicateur</th>
          {sims.map((s) => (
            <th key={s.id} className={`text-left px-4 py-3 font-semibold ${s.id === refSim.id ? "bg-genis/10" : ""}`}>
              <div className="truncate max-w-[220px]">{s.name}</div>
              {s.id === refSim.id && <div className="eyebrow text-[9px] text-genis mt-0.5">Référence</div>}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {visibleMetrics(sims).map((m) => (
          <tr key={m.key} className="border-t border-border">
            <td className="px-4 py-2.5 text-muted-foreground">{m.label}</td>
            {sims.map((s) => (
              <td key={s.id} className={`px-4 py-2.5 align-top ${s.id === refSim.id ? "bg-genis/5" : ""}`} data-testid={`cell-${m.key}-${s.id}`}>
                <div className={`${m.num ? "metric" : ""} ${m.strong ? "font-bold text-genis" : ""}`}>{m.get(s)}</div>
                <Delta m={m} s={s} refSim={refSim} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
